export default {
  en: require('./en.json'),
  de: require('./de.json'),
  fr: require('./fr.json'),
  ar: require('./ar.json')
}
